import { Assessment, ElementKind, Question, Section } from '@playbooks/core/src/interfaces/ActionCard'

/**
 * Replace question and option IDs in the given sections with short sequential IDs unique across the result.
 * Action Card IDs are long numbers costing several tokens each in AI Teammate instructions and tool calls.
 * Returns copies of the sections (originals are not modified) and the map of short IDs to the real Action Card IDs.
 */
export function shortenTeammateIds(sections: Section[]): {
  sections: Section[]
  actionCardIdMap: Record<string, number>
} {
  const actionCardIdMap: Record<string, number> = {}
  let lastShortId = 0
  const toShortId = (id: number) => {
    actionCardIdMap[++lastShortId] = id
    return lastShortId
  }

  // Replace IDs of the same nodes the backend lists in the AI instructions: questions, assessments and their options
  const shortIdSections = sections.map(section => ({
    ...section,
    elements: section.elements?.map(element => {
      if (element.kind === ElementKind.QUESTION) {
        const question = element as Question
        return {
          ...question,
          id: toShortId(question.id),
          data: question.data?.map(option => ({ ...option, id: toShortId(option.id) })),
        }
      }
      if (element.kind === ElementKind.ASSESSMENT) {
        const assessment = element as Assessment
        return {
          ...assessment,
          id: toShortId(assessment.id),
          responses: assessment.responses?.map(response => ({ ...response, id: toShortId(response.id) })),
        }
      }
      return element
    }),
  }))

  return { sections: shortIdSections, actionCardIdMap }
}
